// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareFilledSvg from "@ant-design/icons-svg/es/asn/UpSquareFilled";
import AntdIcon from '../components/AntdIcon';

var UpSquareFilled = function UpSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareFilledSvg
  }));
};

UpSquareFilled.displayName = 'UpSquareFilled';
export default React.forwardRef(UpSquareFilled);